import React, { memo } from 'react'
import { FormControl } from '@mui/material'

import CustomFormLabel from '../forms/customElements/CustomFormLabel'
import InputHelperText from './InputHelperText'

const FileField = ({
  label,
  id,
  errorMessage,
  onChange,
  accept,
  ...restProps
}) => {
  const error = Boolean(errorMessage)
  return (
    <FormControl fullWidth error={error}>
      <CustomFormLabel htmlFor={id}>{label}</CustomFormLabel>
      <input type='file' accept={accept} id={id} onChange={onChange} />
      <InputHelperText {...restProps} errorMessage={errorMessage} />
    </FormControl>
  )
}

export default memo(FileField)
